import { useTheme } from '@emotion/react';
import cn from 'classnames';
import { memo } from 'react';
import { useMedia } from 'react-use';

import type {
  ACHIEVEMENT_TIERS,
  ACHIEVEMENT_TYPES,
} from '@didaskill/domain/user-achievements/constants';
import { Achievement } from '@didaskill/ui/design-system';

import * as styles from './AchievementTileIcon.styles';
import { LockIcon } from './LockIcon';

type AchievementTileIconProps = {
  isDisabled: boolean;
  isLocked?: boolean;
  type: ACHIEVEMENT_TYPES;
  tier: ACHIEVEMENT_TIERS;
};

const AchievementTileIconBase = ({
  type,
  tier,
  isDisabled = false,
  isLocked = false,
}: AchievementTileIconProps) => {
  const { breakpoints } = useTheme();

  const isAboveMedium = useMedia(`(min-width: ${breakpoints.medium})`);

  return (
    <div css={styles.achievementTileIconContainer}>
      <div css={styles.iconContainer} className={cn({ isLocked })}>
        <Achievement
          size={isAboveMedium ? Achievement.SIZES.MEDIUM : Achievement.SIZES.SMALL}
          type={type}
          tier={tier}
          isDisabled={isDisabled}
        />
      </div>

      {isLocked && (
        <div css={styles.lockIcon}>
          <LockIcon />
        </div>
      )}
    </div>
  );
};

AchievementTileIconBase.displayName = 'AchievementTileIcon';

export const AchievementTileIcon = memo(AchievementTileIconBase);
